import { Components } from '@ionic/core/dist/types/components';
import { IonIcon, IonInput, IonText } from '@ionic/react';
import { FieldConfig, useField } from 'formik';
import { helpCircleOutline } from 'ionicons/icons';
import React, { HTMLAttributes, ReactElement } from 'react';
import { blurOnEnter } from '../../util/keyboard';
import { IonItem } from '../ionic/IonItem';
import { Tooltip } from '../tooltip/tooltip';
import { FieldLocked } from '../ui/field-locked';

export interface IonFormFieldProps extends FieldConfig {
  className?: string;
  label: string;
  blurOnEnter?: boolean;
  inputProps?: Partial<Components.IonInput> &
    Partial<HTMLAttributes<HTMLIonInputElement>> &
    Partial<React.RefAttributes<HTMLIonInputElement>>;
  hidden?: boolean;
  fieldInfo?: string;
}

const IonFormField = (props: IonFormFieldProps): ReactElement => {
  const { label, fieldInfo, inputProps, ...otherProps } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta, helper] = useField(otherProps as any);

  const errorText = <IonText color="danger">{meta.error}</IonText>;

  let labelColor: string | undefined = 'primary';
  if (
    inputProps?.labelPlacement !== undefined &&
    inputProps?.labelPlacement !== 'floating'
  ) {
    labelColor = undefined;
  }

  return (
    <IonItem
      key={meta.initialValue ?? undefined}
      lines={'full'}
      className={props.className}
      hidden={otherProps.hidden}
    >
      <IonInput
        onKeyDown={(e) => {
          if (props.blurOnEnter) {
            blurOnEnter(e);
          }
        }}
        {...field}
        labelPlacement={'floating'}
        {...inputProps}
        onIonInput={(e) => {
          if (e.detail.value !== undefined) {
            helper.setValue(e.detail.value);
          }
        }}
      >
        <div slot="label">
          <IonText color={labelColor}>
            {label}{' '}
            <FieldLocked
              show={inputProps?.readonly || inputProps?.disabled ? true : false}
            />{' '}
            {errorText}
          </IonText>
        </div>
      </IonInput>
      {fieldInfo && (
        <Tooltip
          text={fieldInfo}
          triggerElement={
            <IonIcon
              icon={helpCircleOutline}
              color="primary"
              slot="end"
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          }
        />
      )}
    </IonItem>
  );
};

export { IonFormField };
